import { makeStyles } from '@material-ui/core';

import { neutral } from 'shared/styles/colors';

export default makeStyles(theme => ({
  box: {
    maxWidth: '18rem',
    position: 'absolute',
    backgroundColor: neutral.white,
    margin: 'auto',
    left: '0',
    right: '0',
    top: '6rem',
    borderRadius: '1rem',
    [theme.breakpoints.up('md')]: {
      maxWidth: ({ isPermissionUndefinedOrDenied }) =>
        isPermissionUndefinedOrDenied ? '32rem' : '17.5rem',
      top: '3.5rem',
      left: '4rem',
      right: 'auto',
    },
  },
  root: {
    display: 'flex',
    flexDirection: ({ isPermissionUndefinedOrDenied }) =>
      isPermissionUndefinedOrDenied ? 'row' : 'column',
    alignItems: 'center',
    fontFamily: 'Poppins',
    fontSize: '1.5rem',
    padding: '1rem',
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
    },
  },
  tutorialImg: {
    width: '7rem',
    height: 'auto',
    margin: '0.5rem',
    [theme.breakpoints.up('md')]: {
      display: ({ isPermissionUndefinedOrDenied }) =>
        isPermissionUndefinedOrDenied ? 'block' : 'none',
    },
  },
  header: {
    fontSize: '1.5rem',
    textAlign: 'center',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  text: {
    display: 'flex',
    flexDirection: 'column',
    fontSize: '1rem',
    textWrap: 'pretty',
    padding: '0.5rem 0',
    [theme.breakpoints.up('md')]: {
      fontSize: '0.875rem',
    },
  },
  warningList: {
    margin: '0.75rem 0 0',
    paddingLeft: '1.25rem',
  },
  warningListItem: {
    marginBottom: '0.25rem',
    [theme.breakpoints.up('md')]: {
      fontSize: '0.875rem',
    },
  },
  cta: {
    display: 'flex',
    gap: '0.5rem',
    flexDirection: 'column',
    padding: '0.5rem 1rem 1rem',
    borderTop: ({ isPermissionUndefinedOrDenied }) =>
      isPermissionUndefinedOrDenied ? 'none' : `1px solid ${neutral[20]}`,
    [theme.breakpoints.up('md')]: {
      display: ({ isPermissionUndefinedOrDenied }) =>
        isPermissionUndefinedOrDenied ? 'none' : 'flex',
      flexDirection: 'row-reverse',
    },
  },
  primary: {
    padding: '0.75rem 1rem',
    fontSize: '1rem !important',
    fontFamily: 'Poppins',
    fontWeight: '600',
    [theme.breakpoints.up('md')]: {
      padding: '0.5rem 0.75rem',
      flexDirection: 'row-reverse',
      fontSize: '0.875rem !important',
    },
  },
  cancelBtn: {
    padding: '0.75rem 1rem',
    fontFamily: 'Poppins',
    fontWeight: '600',
    color: neutral.D15,
    [theme.breakpoints.up('md')]: {
      fontSize: '0.875rem !important',
      padding: '0.5rem 0.75rem',
    },
  },
}));
